export class HubProperties {
  public static autoGenerated = 'auto-generated'
  public static enabledScript = 'enabled-script'
  public static enabledOnMobileScript = 'enabled-on-mobile-script'
  public static dataVersion = 'data-version'
  public static enabledApps = 'enabled-apps'

  public static registeredAsPartner = 'registered-as-partner'

  public static usedAndroidApp = 'used-android-app'
  public static mobileAppHintDisabled = 'mobile-app-hint-disabled'
  public static androidIPhoneReuest = 'android-iphone-request'
  public static companyRegistered = 'company-registered'

  public static desktopAppHintDisabled = 'desktop-app-hint-disabled'
  public static usedDesktopApp = 'used-desktop-app'

  public static showMessageStatsInBoard = 'show-message-stats-in-board'
  public static showZeroMessageStatsInBoard = 'show-zero-message-stats-in-board'

  public static newsTaskDate = 'news-task-date'
  public static newsTaskType = 'news-task-type'
  public static newsTaskLang = 'news-task-lang'
  public static newsTaskPopup = 'news-task-popup'

  public static scriptsReloadTimestamp = 'scripts-reload-timestamp'

  public static permissionsHintClosed = 'permissions-hint-closed'

  public static triedDarkMode = 'tried-dark-mode'

  static fromSpam = 'from-spam'

  // group chats
  public static groupChatTitle = 'group-chat-title'
  public static groupChatUsers = 'group-chat-users'
  public static groupChatNotified = 'group-chat-notified'
  //
}
